import { render, staticRenderFns } from "./PowerpageCreateForm.vue?vue&type=template&id=44973b35&scoped=true&"
import script from "./PowerpageCreateForm.vue?vue&type=script&lang=js&"
export * from "./PowerpageCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./PowerpageCreateForm.vue?vue&type=style&index=0&id=44973b35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44973b35",
  null
  
)

export default component.exports